import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EngineApiClient {
  private ENGINE_ENDPOINT = environment.signingApiUrl;

  constructor(private http: HttpClient) { }

  
  /**
   * Return the stamp
   * @param stampWidth width of the stamp. by default 600px
   * @param stampHeight height of the stamp. by default 200px
   * @param justText given only the stamp as it should or only the text for scribble/image. by defaut false;0
   * @returns Blob
   */
  getStamp(stampWidth: number = 600, stampHeight: number = 200, justText: boolean = false){
    let utcOffset = (new Date()).getTimezoneOffset() * -1;
    let language = localStorage.getItem('language') && localStorage.getItem('language') != 'undefined' ? localStorage.getItem('language') : "nl";
    let bodyObject = {
      width: stampWidth,
      height: stampHeight,
      language: language,
      utcOffsetMinutes: utcOffset
    };
    if(justText){
      return this.http.post(this.ENGINE_ENDPOINT + "/api/signing/stamptext", bodyObject, { responseType: 'blob' });
    } else {
      return this.http.post(this.ENGINE_ENDPOINT + "/api/signing/stamp", bodyObject, { responseType: 'blob' });
    }
  }
}